import type { CurrentUserStatus } from '@/api/v4/auth.api';

export type TeamMemberStatus = CurrentUserStatus;

export const basicTabConfig: TeamMemberStatus[] = ['active', 'invited'];
